import React from "react";
import textJson from "../style/text";
export const JsonContext = React.createContext({
  JSON: textJson[0]["en"],
});
